import {Component, CUSTOM_ELEMENTS_SCHEMA, inject} from '@angular/core';
import {Router, RouterOutlet} from "@angular/router";
import {AuthService} from '../../security/auth.service';
import {NgDynamicComponentsService} from '../../service/ng-dynamic-components.service';
import {MarkdownRendererComponent} from '../../components/markdown-renderer/markdown-renderer.component';
import {AppNavigationLinkComponent} from '../../components/app-navigation-link/app-navigation-link.component';
import {
    AppNavigationLinkSubitemComponent
} from '../../components/app-navigation-link-subitem/app-navigation-link-subitem.component';
import {NavBarComponent} from '../../components/nav-bar/nav-bar.component';
import { PortfolioSegmentDataContext } from '../../data/portfolio-segment-data-context.service';

@Component({
    selector: 'app-test-layout',
    standalone: true,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        RouterOutlet,
        AppNavigationLinkComponent,
        NavBarComponent
    ],
    templateUrl: './test-layout.component.html',
    styleUrl: './test-layout.component.scss',
    providers:  [
        PortfolioSegmentDataContext
    ]
})
export class TestLayoutComponent {

    protected authService = inject(AuthService)
    private dialogService = inject(NgDynamicComponentsService);
    private router = inject(Router);

    protected async onUserLogin() {
        await this.authService.login();
        const accessToken = this.authService.accessToken;
        const idToken = this.authService.idToken;
        console.log('accessToken', accessToken);
        console.log('idToken', idToken);
    }

    protected async onUserLogout() {
        await this.authService.logout();
    }

    async onExecuteTest() {
        await this.dialogService.createComponentDialog(MarkdownRendererComponent, {
            title: 'Test Markdown',
            titleIconClass: 'far fa-file-alt',
            input: { markdown: '# Test Markdown' },
        });
    }

    async onShowUserDetails() {
        await this.router.navigateByUrl('/test/userdetails');
    }
}
